module.exports = __webpack_public_path__ + "files/ccc07df437823426757b31de84584de3.png";